import { decoratedCa } from 'shared/mf-infrastructure/utils/analytics';

interface ITrackPanoramaOpenParams {
  objectType: string | null;
  blockType: string;
  profile: string | null;
}

export function trackPanoramaOpen({ objectType, blockType, profile }: ITrackPanoramaOpenParams) {
  decoratedCa('eventSite', {
    action: 'click_sopr',
    category: 'Infrastructure',
    label: 'panorama',
    name: 'oldevent',
    page: {
      extra: {
        profile,
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
